import * as Diagram from "../../../../components/diagram";

export const CaseInformationInventory = {
  label: "個案案件資料清冊",
  key: "CaseInformationInventory",
  path: "PsychologicalCounseling/CaseInformationInventory",
  api: "TCS_V_PsychologicalCounseling_1",
  render: (options) => (
    <Diagram.PsychologicalCounseling.CaseInformationInventory {...options} />
  ),
  isRaw: true,
  isPage: true,
  dateRangeColumns: [{ label: "開案日期", key: "開案日期" }],
  columns: [
    {
      key: "姓名",
      field: "姓名",
      header: "姓名",
    },
    {
      key: "身分證字號",
      field: "身分證字號",
      header: "身分證字號",
    },
    {
      key: "性別",
      field: "性別",
      header: "性別",
    },
    {
      key: "生日",
      field: "生日",
      header: "生日",
    },
    {
      key: "連絡電話",
      field: "連絡電話",
      header: "連絡電話",
    },
    {
      key: "行動電話",
      field: "行動電話",
      header: "行動電話",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "個案來源",
      field: "個案來源",
      header: "個案來源",
    },
    {
      key: "開案日期",
      field: "開案日期",
      header: "開案日期",
    },
    {
      key: "個案類型",
      field: "個案類型",
      header: "個案類型",
    },
  ],
};
